@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/screen-width-breakpoints.module.less';

.create-label-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.header {
  height: 50px;
  border-bottom: 1px solid @create-label--border-color;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: @create-label--text-color;
  font-size: 12px;
  position: relative;
  z-index: 2;
  background: @create-label--background-color;
}

.back-to-rates-button {
  > svg {
    height: 30px;
    width: 30px;
    margin-left: -10px;
    padding: 9px;
  }

  > * {
    vertical-align: top;
  }
}

.body {
  position: relative;
  z-index: 1;
  display: flex;
  height: calc(100% - 50px);
  max-height: calc(100% - 50px);

  @media @mobile, @ultramobile {
    flex-direction: column;
    overflow-y: auto;
    max-height: none;
    height: auto;
    flex: 1;
  }
}

.left-section {
  position: relative;
  z-index: 2;
  width: 560px;
  padding: 15px;
  border-right: 1px solid @create-label--border-color;

  > * {
    margin-bottom: 10px;
  }

  @media @mobile, @ultramobile {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid @create-label--border-color;
  }
}

.right-section {
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 1;
  width: 445px;
  background: @create-label--background-color;
  padding: 10px 0;
  overflow: auto;
  align-items: center;

  @media @mobile, @ultramobile {
    width: 100%;
    overflow: visible;
  }
}

.shipping-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  align-items: center;
}

.validate-address-button-wrapper {
  margin-bottom: 15px;
}

.customs-declarations {
  align-self: stretch;
}

.other-and-customs-wrapper {
  width: 100%;
}

.create-return-label-checkbox {
  font-size: 14px;
}

.fulfillment-planner-wrapper {
  border-bottom: 1px solid @create-label--border-color;
}

.email-field-helper-message {
  padding-left: 85px;
  font-size: 14px;
}
